"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("./styles");
/**
 * Converts a decimal number to a hexadecimal string.
 * @param {number} decimal - The decimal number.
 * @returns {string} The hexadecimal string.
 */
var decimalToHexadecimal = function (decimal) { var _a; return (_a = decimal === null || decimal === void 0 ? void 0 : decimal.toString(16)) === null || _a === void 0 ? void 0 : _a.padStart(2, '0'); };
/**
 * Converts a hexadecimal string to a decimal number.
 * @param {string} hexadecimal - The hexadecimal string.
 * @returns {number} The decimal number.
 */
var hexadecimalToDecimal = function (hexadecimal) {
    return parseInt(hexadecimal, 16);
};
/**
 * Mixes two colors.
 * @param {string} color1 - The first color in hexadecimal format.
 * @param {string} color2 - The second color in hexadecimal format.
 * @param {number} weight - The weight of the first color in the mix.
 * @returns {string} The resulting color in hexadecimal format.
 */
var mixColors = function (color1, color2, weight) {
    var mixedColor = '#';
    for (var i = 1; i <= 6; i += 2) {
        var color1Part = hexadecimalToDecimal(color1 === null || color1 === void 0 ? void 0 : color1.substr(i, 2));
        var color2Part = hexadecimalToDecimal(color2 === null || color2 === void 0 ? void 0 : color2.substr(i, 2));
        var mixedPart = decimalToHexadecimal(Math.round(color2Part + (color1Part - color2Part) * (weight / 100.0)));
        mixedColor += mixedPart;
    }
    return mixedColor;
};
/**
 * Generates client colors based on a base color.
 * @param {string} baseColor - The base color in hexadecimal format.
 * @returns {Array} The generated client colors.
 */
var generateClientColors = function (baseColor) {
    var opacities = [8, 15, 30, 45, 60, 85, 100, 85, 70, 55, 40];
    return opacities.map(function (opacity, index) { return ({
        label: styles_1.labels[index],
        color: mixColors(baseColor, styles_1.baseColors[index], opacity),
    }); });
};
exports.default = generateClientColors;
//# sourceMappingURL=generateClientColors.js.map